import { PensionPage } from '../components/pages'

export default PensionPage
